// ids of each of the endpoints is the elemental block ID
export const futureCaptainEndpoint = (id) => `/api/submission/${id}/future-captain`
export const localLegendEndpoint = (id) => `/api/submission/${id}/local-legend`
export const netballGrantEndpoint = (id) => `/api/submission/${id}/netball-grant`
export const contactUsEndpoint = (id) => `/api/submission/${id}/contact-us`

const handleFormSubmit = (values, endpoint) => {
    return fetch(endpoint, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-requested-with': 'XMLHttpRequest'
            },
            body: JSON.stringify({...values}, null, 2),
        }
    ).then((res) => res.json());
}

export default handleFormSubmit;
